// extracted by mini-css-extract-plugin
export var parcelRow = "_v2-0";